<template>
  <div class="genplan" id="genplan_app">
    <div class="genplan-main"
      :style="{width: sizes.current.width + 'px', height: sizes.current.height + 'px'}">
      <div class="genplan-activate" v-show="isTouch&&!isActive" @click="isActive=true">
        <div class="genplan-activate-text">Нажмите для взаимодействия</div>
      </div>
      <div class="genplan-small"
        v-show="!view.isZoom" @wheel="zoomInWheel" @contextmenu="block"
        :style="{transform: computePreviewTransform(),
          width: sizes.preview.width + 'px', height: sizes.preview.height + 'px'}"
        :click="zoomIn"
        @mousedown="previewDragStart"
        @touchstart="previewDragStart"
        @mousemove="dragMove"
        @touchmove="dragMove"
        @mouseup="dragEnd"
        @touchend="dragEnd"
        @mouseleave="dragEnd"
      >
        <div
          class="genplan-house"
          :class="{sold: houseIsSold(index)}"
          @click="zoomIn($event, house)"
          v-for="(house, index) in houses" :key="index"
          :style="{transform: computeHouseTransform(house, false)}"
        >
          <div class="genplan-house-number genplan-house-number" >
            {{ house.text }}
          </div>
        </div>
      </div>
      <div class="genplan-large" v-show="view.isZoom"
        @contextmenu="zoomOut"
        @wheel="zoomOutWheel"
        @mousedown="fullDragStart"
        @touchstart="fullDragStart"
        @mousemove="dragMove"
        @touchmove="dragMove"
        @mouseup="dragEnd"
        @touchend="dragEnd"
        @mouseleave="dragEnd"
        :style="{transform: computeFullTransform(),
        width: sizes.full.width + 'px', height: sizes.full.height + 'px'}"
      >
        <div
          class="genplan-house-big"
          :class="{'selected': houseIsSelected(index), 'sold': houseIsSold(index)}"
          @click="houseClick($event, index)"
          @mousedown="houseDragStart($event, index)"
          v-for="(house, index) in houses" :key="index"
          :style="{transform: computeHouseTransform(house, true)}"
        >
          <div class="genplan-house-big-number">
            <div class="genplan-house-big-number-top" >{{ house.text }}</div>
            <div class="genplan-house-big-number-bottom">{{ house.text2 }}</div>
          </div>
        </div>
      </div>
      <div class="genplan-toolbar" v-show="view.isZoom">
        <button class="genplan-toolbar-button"
          v-if="mode=='edit'&&hasUnsavedChanges" @click="save()"
        >
          <img src="./assets/save.svg" alt="-">
        </button>
        <button class="genplan-toolbar-button"
          :class="{active: edit.isCreateMode}"
          v-if="mode=='edit'" @click="houseCreateMode()"
        >
          <img src="./assets/add.svg" alt="-">
        </button>
        <button class="genplan-toolbar-button"
          :class="{active: houseIsSold()}"
          v-if="mode=='edit'&&houseIsSelected()" @click="houseSetSold()"
        >
          <img src="./assets/sold-sign.svg" alt="-">
        </button>
        <button class="genplan-toolbar-button"
          v-if="mode=='edit'&&houseIsSelected()" @click="houseEditContent()"
        >
          <img src="./assets/edit-tools.svg" alt="-">
        </button>
        <button class="genplan-toolbar-button"
          v-if="mode=='edit'&&houseIsSelected()" @click="houseRemove()"
        >
          <img src="./assets/send-to-trash.svg" alt="-">
        </button>
        <button class="genplan-toolbar-button" @click="zoomOut"
        >
          <img src="./assets/zoom.svg" alt="-">
        </button>
      </div>
      <div class="genplan-modals">
        <div class="modal" v-show="modals.editHouseText.show">
          <div class="modal-wrapper">
            <div class="modal-title">Редактировать</div>
            <div class="modal-content">
              <div class="modal-form-row">
                <input class="modal-form-input"
                  type="text" placeholder="Текст 1" v-model="modals.editHouseText.inputText1">
              </div>
              <div class="modal-form-row">
                <input class="modal-form-input"
                  type="text" placeholder="Текст 2" v-model="modals.editHouseText.inputText2">
              </div>
            </div>
            <div class="modal-buttons">
              <button class="modal-button apply" @click="modalEditTextApply">Применить</button>
              <button class="modal-button cancel" @click="modalEditTextClose">Отмена</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */

export default {
  name: 'Genplan',
  props: ['data', 'auth-key', 'initial-mode'],

  data() {
    return {

      mode: 'view',

      hasUnsavedChanges: false,

      touchMultiplier: 1.5,

      isActive: false,

      modals: {
        editHouseText: {
          show: false,
          title: false,
          callback: null,
          inputText1: '',
          inputText2: '',
        },
      },

      view: {
        isZoom: false,
      },

      edit: {
        selectedHouseIndex: null,
        isCreateMode: false,
      },

      sizes: {
        current: {
          width: 0,
          height: 0,
        },
        preview: {
          width: 959,
          height: 684,
        },
        full: {
          width: 4000,
          height: 2853,
        },
      },

      dragState: {
        isActive: false,
        originX: 0,
        originY: 0,
        houseOriginX: 0,
        houseOriginY: 0,
        currentX: 0,
        currentY: 0,
        wasMove: false,
        initialEvent: null,
      },

      previewPos: {
        x: 0,
        y: 0,
        ox: null,
        oy: null,
      },

      fullPos: {
        x: 0,
        y: 0,
        ox: null,
        oy: null,
      },

      houses: [
        /* { x: 86.5, y: 50.5, text: '112', text2: '619', sold: false }, */
      ],

    };
  },

  methods: {


    /* Service */

    block(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    },
    getEventCoords(ev, disableTouchMultiplier = false) {
      let mult = this.touchMultiplier;
      if (disableTouchMultiplier) {
        mult = 1;
      }
      if (ev.touches) {
        if (ev.touches[0]) {
          return { x: ev.touches[0].clientX * mult, y: ev.touches[0].clientY * mult };
        }
      }
      return { x: ev.clientX, y: ev.clientY };
    },


    /* Drag */

    fullDragStart(ev) {
      ev.preventDefault();
      if (this.houseIsSelected()) {
        this.houseUnselect();
      }
      if (this.edit.isCreateMode) {
        this.edit.isCreateMode = false;
        this.houseCreate(ev);
        return;
      }
      this.dragState.wasMove = false;
      this.dragState.mode = 'zoom';
      this.dragState.isActive = true;
      this.dragState.originX = this.getEventCoords(ev).x;
      this.dragState.originY = this.getEventCoords(ev).y;
      this.fullPos.ox = this.fullPos.x;
      this.fullPos.oy = this.fullPos.y;
    },

    previewDragStart(ev) {
      ev.preventDefault();
      this.dragState.wasMove = false;
      this.dragState.mode = 'preview';
      this.dragState.isActive = true;
      this.dragState.originX = this.getEventCoords(ev).x;
      this.dragState.originY = this.getEventCoords(ev).y;
      this.dragState.initialEvent = ev;
      this.previewPos.ox = this.previewPos.x;
      this.previewPos.oy = this.previewPos.y;
    },

    dragMove(ev) {
      ev.preventDefault();
      if (!this.dragState.isActive) return;
      const x = this.dragState.originX - this.getEventCoords(ev).x;
      const y = this.dragState.originY - this.getEventCoords(ev).y;
      this.dragState.currentX = x;
      this.dragState.currentY = y;
      if (Math.abs(x) > 5 || Math.abs(y) > 5) {
        this.dragState.wasMove = true;
      }
      if (!this.dragState.wasMove) {
        return;
      }
      if (this.dragState.mode === 'zoom') {
        const distZoomX = this.fullPos.ox - x;
        const distZoomY = this.fullPos.oy - y;
        this.setFullPos(distZoomX, distZoomY);
      } else if (this.dragState.mode === 'preview') {
        const distZoomX = this.previewPos.ox - x;
        const distZoomY = this.previewPos.oy - y;
        this.setPreviewPos(distZoomX, distZoomY);
      } else if (this.dragState.mode === 'house') {
        const distX = this.dragState.houseOriginX - x;
        const distY = this.dragState.houseOriginY - y;
        this.houseSetPos(this.edit.selectedHouseIndex, distX, distY, true);
      }
    },

    dragEnd(ev) {
      ev.preventDefault();
      if (!this.dragState.isActive) return;
      this.dragState.isActive = false;
      const x = this.dragState.originX - this.getEventCoords(ev).x;
      const y = this.dragState.originY - this.getEventCoords(ev).y;
      if (!this.dragState.wasMove) {
        if (this.dragState.mode === 'preview') {
          this.zoomIn(this.dragState.initialEvent);
        }
        return;
      }
      if (this.dragState.mode === 'house') {
        const distX = this.dragState.houseOriginX - x;
        const distY = this.dragState.houseOriginY - y;
        this.hasUnsavedChanges = true;
        this.houseSetPos(this.edit.selectedHouseIndex, distX, distY);
      }
    },

    /* Preview */
    setPreviewPos(ix, iy) {
      let x = ix;
      let y = iy;
      const minX = 0 - (this.sizes.preview.width - this.sizes.current.width);
      const minY = 0 - (this.sizes.preview.height - this.sizes.current.height);
      if (x > 0) x = 0;
      if (x < minX) x = minX;
      if (y > 0) y = 0;
      if (y < minY) y = minY;
      this.previewPos = {
        ...this.previewPos,
        x,
        y,
      };
    },


    /* Zoom */

    zoomIn(ev, house) {
      if (house) {
        this.setFullPosPercent(house.x, house.y);
      } else {
        this.setFullPosPercent(
          (this.getEventCoords(ev, true).x - this.previewPos.x) / (this.sizes.preview.width / 100),
          (this.getEventCoords(ev, true).y - this.previewPos.y) / (this.sizes.preview.height / 100),
        );
      }
      ev.stopPropagation();
      this.view.isZoom = true;
    },

    zoomInWheel(ev) {
      if (ev.deltaY < 0) {
        this.setFullPosPercent(
          (this.getEventCoords(ev).x - this.previewPos.x) / (this.sizes.preview.width / 100),
          (this.getEventCoords(ev).y - this.previewPos.y) / (this.sizes.preview.height / 100),
        );
        this.view.isZoom = true;
      }
    },

    zoomOutWheel(ev) {
      if (ev.deltaY > 0) {
        this.zoomOut();
      }
    },

    zoomOut(ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      this.view.isZoom = false;
    },

    zoomToggle() {
      this.view.isZoom = !this.view.isZoom;
    },

    setFullPos(ix, iy) {
      let x = ix;
      let y = iy;
      const minX = 0 - (this.sizes.full.width - this.sizes.current.width);
      const minY = 0 - (this.sizes.full.height - this.sizes.current.height);
      if (x > 0) x = 0;
      if (x < minX) x = minX;
      if (y > 0) y = 0;
      if (y < minY) y = minY;
      this.fullPos = {
        ...this.fullPos,
        x,
        y,
      };
    },

    setFullPosPercent(px, py) {
      this.fullPos = {
        ...this.fullPos,
        x: this.getfullPosOffsetFor('x', px),
        y: this.getfullPosOffsetFor('y', py),
      };
    },

    getfullPosOffsetFor(dimension, percent) {
      let propLength = 'width';
      if (dimension === 'y') {
        propLength = 'height';
      }
      const minX = 0 - (this.sizes.full[propLength] - this.sizes.current[propLength]);
      const r = (0 - (this.sizes.full[propLength] / 100) * percent) + this.sizes.current[propLength] / 2;
      if (r < minX) return minX;
      if (r > 0) return 0;
      return r;
    },

    computePreviewTransform() {
      const distX = this.previewPos.x;
      const distY = this.previewPos.y;
      return `translateY(${distY}px) translateX(${distX}px)`;
    },


    computeFullTransform() {
      const distX = this.fullPos.x;
      const distY = this.fullPos.y;
      return `translateY(${distY}px) translateX(${distX}px)`;
    },


    /* Houses */

    houseGetCoords(house, isBig = true) {
      const { x, y, tx, ty } = house;
      if (tx !== undefined && ty !== undefined) {
        return { x: tx, y: ty };
      }
      let width;
      let height;
      if (isBig) {
        width = this.sizes.full.width;
        height = this.sizes.full.height;
      } else {
        width = this.sizes.preview.width;
        height = this.sizes.preview.height;
      }
      const rx = (width / 100) * x;
      const ry = (height / 100) * y;
      return { x: rx, y: ry };
    },

    computeHouseTransform(house, isBig) {
      const coords = this.houseGetCoords(house, isBig);
      const { x, y } = coords;
      let offset = 28;
      if (!isBig) {
        offset = 11;
      }
      return `translateY(${y - offset}px) translateX(${x - offset}px)`;
    },

    houseSetPos(index, x, y, temp = false) {
      if (temp) {
        this.houses[index].tx = x;
        this.houses[index].ty = y;
      } else {
        delete (this.houses[index].tx);
        delete (this.houses[index].ty);
      }
      const { width } = this.sizes.full;
      const { height } = this.sizes.full;
      const xp = x / (width / 100);
      const yp = y / (height / 100);
      this.houses[index].x = xp;
      this.houses[index].y = yp;
    },

    houseSelect(houseIndex) {
      this.edit.selectedHouseIndex = houseIndex;
    },

    houseUnselect() {
      this.edit.selectedHouseIndex = null;
    },

    houseClick() {

    },

    houseIsSelected(index) {
      if (index !== undefined) {
        if (this.edit.selectedHouseIndex === index) return true;
        return false;
      }
      if (this.edit.selectedHouseIndex !== null) return true;
      return false;
    },

    houseIsSold(index) {
      let house;
      if (index !== undefined) {
        house = this.houses[index];
      } else {
        house = this.houseGetSelected();
      }
      if (!house) return false;
      if (house.sold) return true;
      return false;
    },

    houseSetSold() {
      this.houses[this.edit.selectedHouseIndex].sold = !this.houses[this.edit.selectedHouseIndex].sold;
      this.hasUnsavedChanges = true;
    },

    houseGetSelected() {
      if (!this.houseIsSelected()) return null;
      return this.houses[this.edit.selectedHouseIndex];
    },

    houseRemove() {
      if (!this.houseIsSelected()) return;
      this.houses.splice(this.edit.selectedHouseIndex, 1);
      this.houseUnselect();
      this.hasUnsavedChanges = true;
    },

    houseEditContent() {
      if (!this.houseIsSelected()) return;
      const house = this.houseGetSelected();
      const { text } = house;
      const { text2 } = house;
      this.modalEditText((t1, t2) => {
        this.houses[this.edit.selectedHouseIndex].text = t1;
        this.houses[this.edit.selectedHouseIndex].text2 = t2;
        this.hasUnsavedChanges = true;
      }, 'Редактировать', text, text2);
    },

    houseCreateMode() {
      this.edit.isCreateMode = true;
    },

    houseDragStart(ev, houseIndex) {
      ev.stopPropagation();
      const coords = this.houseGetCoords(this.houses[houseIndex]);
      if (this.mode === 'edit') {
        this.houseSelect(houseIndex);
        this.dragState = {
          ...this.dragState,
          isActive: true,
          wasMove: false,
          mode: 'house',
          originX: this.getEventCoords(ev).x,
          originY: this.getEventCoords(ev).y,
          houseOriginX: coords.x,
          houseOriginY: coords.y,
        };
      }
    },

    houseDragMove(ev) {
      ev.stopPropagation();
    },

    houseDragEnd(ev) {
      ev.stopPropagation();
    },

    houseCreate(ev) {
      const house = { x: 0, y: 0, sold: false, text: '', text2: '' };
      this.houses.push(house);
      const index = this.houses.length - 1;
      const x = this.getEventCoords(ev, true).x + Math.abs(this.fullPos.x);
      const y = this.getEventCoords(ev, true).y + Math.abs(this.fullPos.y);
      this.hasUnsavedChanges = true;
      this.houseSelect(index);
      this.houseSetPos(index, x, y);
      this.modalEditText((t1, t2) => {
        this.houses[this.edit.selectedHouseIndex].text = t1;
        this.houses[this.edit.selectedHouseIndex].text2 = t2;
        this.hasUnsavedChanges = true;
      }, 'Редактировать', '', '');
    },


    /* Save */

    save() {
      const data = JSON.stringify(this.houses);
      const xhr = new XMLHttpRequest();
      const body = `action=save&key=${encodeURIComponent(this.authKey)}&data=${encodeURIComponent(data)}`;
      xhr.open('POST', '', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.send(body);
      this.hasUnsavedChanges = false;
    },


    /* Modals */

    modalEditText(clb, title = 'Редактировать', text1, text2) {
      if (typeof clb === 'function') {
        this.modals.editHouseText.callback = clb;
      }
      this.modals.editHouseText.title = title;
      if (text1 !== undefined) {
        this.modals.editHouseText.inputText1 = text1;
      }
      if (text2 !== undefined) {
        this.modals.editHouseText.inputText2 = text2;
      }
      this.modals.editHouseText.show = true;
    },

    modalEditTextApply() {
      if (typeof this.modals.editHouseText.callback === 'function') {
        this.modals.editHouseText.callback(this.modals.editHouseText.inputText1, this.modals.editHouseText.inputText2);
      }
      this.modalEditTextClose();
    },

    modalEditTextClose() {
      this.modals.editHouseText.inputText1 = '';
      this.modals.editHouseText.inputText2 = '';
      this.modals.editHouseText.show = false;
    },

    nsp: {
      test() {
        alert(this.houses);
      },
    },

    viewportGetSize() {
      const win = window;
      const doc = document;
      const docElem = doc.documentElement;
      const body = doc.getElementsByTagName('body')[0];
      const width = win.innerWidth || docElem.clientWidth || body.clientWidth;
      const height = win.innerHeight || docElem.clientHeight || body.clientHeight;
      return { width, height };
    },

    onResize() {
      const vs = this.viewportGetSize();
      if (vs.width <= this.sizes.preview.width) {
        this.sizes.current.width = vs.width;
      } else {
        this.sizes.current.width = this.sizes.preview.width;
      }
      if (vs.height <= this.sizes.preview.height) {
        this.sizes.current.height = vs.height;
      } else {
        this.sizes.current.height = this.sizes.preview.height;
      }
    },

  },
  computed: {
    isTouch() {
      try {
        document.createEvent('TouchEvent');
        return true;
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    window.addEventListener('resize', () => this.onResize(), false);
    this.onResize();
    if (this.initialMode) {
      this.mode = this.initialMode;
    }
    if (this.data) {
      let data = null;
      try {
        data = JSON.parse(this.data);
      } catch (e) {
        console.error(e);
      }
      if (data) {
        this.houses = data;
      }
    }
    window.genplan = this;
  },
};
</script>

<style lang="scss">
html, body {
  margin: 0px;
  padding: 0px;
}
.genplan-main {
  background: #f5f5f5;
  width: 959px;
  height: 684px;
  position: relative;
  overflow: hidden;
}
.genplan-small {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;;
  background-image: url(./assets/plan.jpg);
  background-size: contain;
  background-repeat: no-repeat;
}

.genplan-large {
  position: absolute;
  top: 0px;
  left: 0px;
  background-image: url(./assets/plan.jpg);
  width: 4000px;
  height: 2853px;
}

.genplan-house {
  position: absolute;
  font-family: arial;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 12px;
  background: #fff;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s;
}

.genplan-house-big {
  position: absolute;
  font-family: arial;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  font-size: 16px;
  background: #fff;
  border: 3px solid transparent;
  /* line-height: 32px; */
  text-align: center;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.3s;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.genplan-house-big.selected {
  border: 3px solid green;
  opacity: 1;
}

.genplan-house-big.sold, .genplan-house.sold {
  background: #ff4242;
  color: #fff;
  cursor: default;
}

.genplan-house:hover, .genplan-house-big:hover {
  opacity: 1;
}

.genplan-house-big-number-top {
  font-weight: 600;
}

.genplan-house-big-number {

}

.genplan-min {
  position: absolute;
  margin: auto;
  text-align: center;
  cursor: pointer;
  right: 0px;
  width: 120px;
  height: 50px;
  line-height: 50px;
  background-color: green;
  font-family: arial;
  color: #fff;
}


.genplan-toolbar {
  position: absolute;
  // position: fixed;
  right: 0px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-end;
}

button.genplan-toolbar-button {
  border: none;
  background: rgba(255,255,255,0.8);
  width: 50px;
  height: 50px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0px;
  opacity: 0.55;
  transition: all 0.3s;
}

button.genplan-toolbar-button:hover {
  opacity: 1;
}

button.genplan-toolbar-button img {
  max-width: 20px;
  height: auto;
  line-height: 10px;
}

.genplan-toolbar-button.active {
  opacity: 1;
  border: 4px solid green;
  background: #ffffff;
}

/* Modals */

.modal {
  background: rgba(255,255,255,0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal-wrapper {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  min-width: 400px;
}

.modal-title {
  font-family: arial;
  font-size: 22px;
  margin-top: 0px;
  margin-bottom: 12px;
}

.modal-form-row {
  margin-bottom: 12px;
}

input.modal-form-input {
  outline: none;
  border: 1px solid #ddd;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
}

.modal-button {
  border: none;
  background: #0095ff;
  padding: 13px;
  padding-left: 18px;
  padding-right: 18px;
  color: #fff;
  font-weight: 400;
  font-size: 16px;
  outline: none;
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.3s;
}

.modal-button:hover {
  opacity: 1;
}

.modal-button.cancel {
  background: transparent;
  color: red;
}

.genplan-activate {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  background: rgba(255,255,255,0.75);
  cursor: pointer;
  font-family: arial;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
</style>
